import React, { createContext, useContext, useState } from "react";

const PanelsContext = createContext(null);

export const PanelsProvider = ({ children }) => {
  const [isTicketsOpen, setIsTicketsOpen] = useState(false);
  const [isNotesOpen, setIsNotesOpen] = useState(false);

  return (
    <PanelsContext.Provider
      value={{
        isTicketsOpen,
        setIsTicketsOpen,
        isNotesOpen,
        setIsNotesOpen,
      }}
    >
      {children}
    </PanelsContext.Provider>
  );
};

export const usePanels = () => {
  const ctx = useContext(PanelsContext);
  if (!ctx) throw new Error("usePanels must be used within PanelsProvider");
  return ctx;
};

export default PanelsContext;
